// extracted by mini-css-extract-plugin
module.exports = {"container":"_1aEQlgGIMffd246xI9tQpj"};